import { FC, useEffect } from 'react'
import { useRangeSlider } from '@ucheba/ui/components/RangeSlider/bll'
import RangeSlider from '@ucheba/ui/components/RangeSlider/desktop'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { EQueryKeysByPrice } from '@ucheba/store/institutions/programs/types'
import { useRouter } from 'next/router'
import { IProgramsPagePriceFacet } from '../types'
import { useSubmitRangeFacet } from '../bll'

const ProgramsPagePriceFacet: FC<IProgramsPagePriceFacet> = (props) => {
  const { max, min } = props
  const router = useRouter()
  const { query } = router
  const { values, setValues } = useRangeSlider(min, max)
  const onSubmit = useSubmitRangeFacet(
    EQueryKeysByPrice.priceFrom,
    EQueryKeysByPrice.priceTo
  )

  useEffect(() => {
    setValues({
      min: query[EQueryKeysByPrice.priceFrom]
        ? Number(query[EQueryKeysByPrice.priceFrom])
        : min,
      max: query[EQueryKeysByPrice.priceTo]
        ? Number(query[EQueryKeysByPrice.priceTo])
        : max,
    })
  }, [query, setValues, min, max])

  return (
    <>
      <div>
        <Text fontWeight='bold'>Стоимость, р.</Text>

        <Spacing spacing='medium' />

        <RangeSlider
          min={min}
          max={max}
          step={1}
          values={values}
          setValues={setValues}
          afterChange={async (minValue, maxValue) => {
            onSubmit(minValue, maxValue)
          }}
        />

        <Spacing spacing='xxlarge' />
      </div>
    </>
  )
}

export default ProgramsPagePriceFacet
